<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import ActiveIngresosQueue from '../widgets/ActiveIngresosQueue.svelte';
  import LabQueueWidget from '../widgets/LabQueueWidget.svelte';
  import ImagenQueueWidget from '../widgets/ImagenQueueWidget.svelte';
  import OpenCuentasWidget from '../widgets/OpenCuentasWidget.svelte';
  import OpsTimeline from '../widgets/OpsTimeline.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import { Ingresos, Episodios, Cuentas, Laboratorio, Imagenologia } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let ingresos = $state(0);
  let episodios = $state(0);
  let cuentas = $state(0);
  let labVal = $state(0);
  let imgInf = $state(0);

  async function cargar() {
    const [ing, eps, cta, lab, img] = await Promise.all([
      Ingresos.activos().catch(() => []),
      Episodios.abiertos('HOSPITALIZACION').catch(() => []),
      Cuentas.list().catch(() => []),
      Laboratorio.ordenes('VALIDADA').catch(() => []),
      Imagenologia.ordenes('INFORMADA').catch(() => []),
    ]);
    ingresos = ing.length;
    episodios = eps.length;
    cuentas = cta.filter(c => c.estado === 'ABIERTA' || !c.estado).length;
    labVal = lab.length;
    imgInf = img.length;
  }

  const actions = [
    { id: 'pacientes', label: 'Pacientes', icon: '' },
    { id: 'expediente', label: 'Expediente CUI', icon: '' },
    { id: 'laboratorio', label: 'Laboratorio', icon: '' },
    { id: 'cuentas', label: 'Cuentas', icon: '' },
    { id: 'reportes', label: 'Reportes', icon: '' },
  ];

  $effect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Auditoría" subtitle="Vista de cumplimiento — solo lectura operativa" variant="auditoria">
  <DashHero emoji='' title="Auditoría clínica" subtitle="Trazabilidad de ingresos, resultados validados y facturación" variant="auditoria" />
  <QuickActions {actions} onAction={onNavigate} />

  <div class="dash-kpis">
    <div class="dash-kpi"><div class="dash-kpi-label">Ingresos activos</div><div class="dash-kpi-value">{ingresos}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Episodios hosp.</div><div class="dash-kpi-value">{episodios}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Cuentas abiertas</div><div class="dash-kpi-value">{cuentas}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Lab validados</div><div class="dash-kpi-value">{labVal}</div></div>
  </div>

  <div class="dash-grid">
    <div class="col-6"><ActiveIngresosQueue limit={10} /></div>
    <div class="col-6"><OpenCuentasWidget limit={10} /></div>
    <div class="col-6"><LabQueueWidget limit={8} /></div>
    <div class="col-6"><ImagenQueueWidget limit={8} {onNavigate} /></div>
    <div class="col-12"><OpsTimeline limit={12} /></div>
  </div>
</DashboardLayout>
